import React from 'react'

import { useIntl } from 'react-intl'
import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Flex
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { GOOGLE_FAQ_URL, GOOGLE_PRIVACY_URL } from 'Constants/index'
import { modalThirdPartyState } from '../recoil/state/modals'
import { updateThirdPartyCallback } from '../recoil/callbacks/callbacks'

export const ModalThirdParty = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalThirdPartyState)

  const updateThirdPartyResourceAlertState = useRecoilCallback(
    updateThirdPartyCallback,
    []
  )

  return (
    <Modal
      show={show}
      showClose={false}
      closeOnOverlayClick={false}
      data-mu-test='modal-template-third-party'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Bee.ModalForThirdPartyResourcesTitle'
        })}
      />
      <ModalBody>
        {intl.formatMessage(
          {
            id: 'Load.Bee.ModalForThirdPartyResourcesContentIntl'
          },
          {
            faq: content => (
              <a
                key='google-key-faq'
                href={GOOGLE_FAQ_URL}
                target='_blank'
                rel='noopener noreferrer'
                className='textlink-highlight test-warningGoogleFonts'
              >
                {content}
              </a>
            ),
            privacy: content => (
              <a
                key='google-key-privacy'
                href={GOOGLE_PRIVACY_URL}
                target='_blank'
                rel='noopener noreferrer'
                className='textlink-highlight test-warningGoogleFonts'
              >
                {content}
              </a>
            )
          }
        )}
      </ModalBody>
      <ModalFoot>
        <Flex justifyContent='center' width='100%'>
          <Button
            data-mu-test='button-template-third-party'
            onClick={updateThirdPartyResourceAlertState}
            kind='primary'
          >
            {intl.formatMessage({
              id: 'Load.Bee.ModalForThirdPartyResourcesButton'
            })}
          </Button>
        </Flex>
      </ModalFoot>
    </Modal>
  )
}
